import { Model } from '@/clients/http'

import { DashboardHttpParams, DashboardResponses } from '@/types'

export class DashboardModel extends Model {
  public static readonly correlations = {
    GET_DASHBOARD: 'GET_DASHBOARD',
  }

  public static readonly endpoints = {
    getDashboard: (props?: DashboardHttpParams.GetDashboard) =>
      this.createEndpoint({
        url: '/api/backoffice/dashboard',
        params: props?.params,
        query: props?.query,
      }),
  }

  public static readonly getDashboard = async (props?: DashboardHttpParams.GetDashboard) => {
    return this.createHttpRequest<
      DashboardResponses.GetDashboard,
      DashboardResponses.GetDashboardError
    >({
      correlationKey: this.correlations.GET_DASHBOARD,
      payload: {
        method: 'get',
        url: this.endpoints.getDashboard(props),
        useBearerToken: true,
      },
      store: props?.store,
    })
  }
}
